import { createFileRoute } from '@tanstack/react-router';
import { MenuTitle } from '../../types';

export const taStaticData = {
  menuTitle: MenuTitle.TalentAgency
};

export const Route = createFileRoute('/_private-routes/talent-agency')({
  staticData: taStaticData
});
